export class MatrixItemField {
  ID: string;
  FIELD: string;
  NAME: string;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parseArray(json: any[]): MatrixItemField[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new MatrixItemField(j));
        }
      }
    }

    return arr;
  }
}
